import ImagePlaceholder from "@/components/base/ImagePlaceholder";

export default function Hero() {
  return (
    <section className="relative mt-16 md:mt-20 min-h-[420px] md:min-h-[600px] h-auto flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <ImagePlaceholder
          src="https://readdy.ai/api/search-image?query=Professional%20technician%20repairing%20a%20roller%20shutter%20on%20a%20residential%20house%20exterior%2C%20wearing%20work%20uniform%20with%20tools%2C%20warm%20daylight%2C%20clean%20modern%20French%20suburban%20setting%2C%20realistic%20service%20photography%20showing%20quality%20craftsmanship%2C%20professional%20repairman%20at%20work%2C%20editorial%20style%20with%20natural%20colors%20and%20soft%20lighting&width=1600&height=900&seq=hero-reparateur-2026&orientation=landscape"
          alt="Remplacement de moteur Bubendorff de volet roulant à Strasbourg"
          className="absolute inset-0 w-full h-full"
          loading="eager"
          fetchpriority="high"
        />
      </div>
      <div className="absolute inset-0 bg-[#143A66]/70"></div>

      <div className="relative z-10 w-full max-w-[80%] mx-auto px-4 md:px-8 text-center py-8 md:py-16">
        <h1 className="text-2xl md:text-5xl font-bold text-white leading-tight mb-3 md:mb-5 animate-hero-fade-up">
          Remplacement de moteur Bubendorff de volet roulant à Strasbourg
        </h1>
        <p className="text-white/90 text-lg md:text-xl max-w-2xl mx-auto mb-5 md:mb-8 animate-hero-fade-up animate-delay-100 leading-relaxed">
          Votre moteur Bubendorff ne fonctionne plus ? Diagnostic et remplacement rapides dans le Bas-Rhin.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-2 md:gap-4 animate-hero-fade-up animate-delay-200">
          <a
            href="tel:0374473240"
            className="flex items-center justify-center gap-2 bg-brand-cyan text-white px-7 py-3.5 rounded-md font-semibold text-base hover:bg-brand-cyan/90 transition-all duration-200 btn-hover-effect whitespace-nowrap w-full sm:w-auto sm:min-w-[260px]"
          >
            <span className="btn-icon-wrap"><i className="ri-phone-line text-lg"></i></span>
            Appeler le 03 74 47 32 40
          </a>
          <a
            href="#devis"
            className="inline-flex items-center justify-center gap-2 border border-white text-white px-5 py-3 md:px-7 md:py-3.5 rounded-md font-semibold text-base hover:bg-white/10 transition-all duration-200 btn-hover-effect whitespace-nowrap w-full sm:w-auto sm:min-w-[260px]"
          >
            <span className="btn-icon-wrap"><i className="ri-file-list-3-line text-lg"></i></span>
            Devis gratuit
          </a>
        </div>
      </div>
    </section>
  );
}